import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import { typography } from 'styled-system';
import Text from '../../atoms/Text';
export const Content = styled(Text).attrs(({
  isList
}) => ({
  fontSize: [isList ? 0 : 1, 1],
  fontWeight: 'regular',
  lineHeight: ['fontSize', 'display']
}))`
  ${typography}
  margin-bottom: ${() => themeGet('space.2')}px;
`;
export const SrOnlyText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;